import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import textInputModel from "../../../models/general/elements/inputElements/textInput.model";
import TextInputElementComponent from "../../general/elements/inputElements/TextInputElementComponent";
import { bindActionCreators } from "@reduxjs/toolkit";
import { connect } from "react-redux";
import accountActions from "../../../store/actions/accounts/account.actions";

import "../../../styles/components/dialogs/accounts/accountDialogContent.scss";
import { loginCredentials } from "../../../models/accounts/loginCredentials.model";
import validationHelper from "../../../helpers/validation.helper";
import AccountErrorsEnum from "../../../enums/errors/accounts/accountErrors.enum";

const AccountDialogContent = ({ accountActions }) => {
  const navigate = useNavigate();
  const [credentails, setCredentials] = useState(loginCredentials);
  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCredentials({ ...credentails, [name]: value });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!validationHelper.validateEmail(credentails.email)) {
      newErrors.email = "כתובת דואר אלקטרוני לא תקינה";
    }
    if (!validationHelper.validatePassword(credentails.password)) {
      newErrors.password = "אורך הסיסמה חייב להיות לפחות 6 תווים";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const getLoginErrorMessage = (errorCode) => {
    switch (errorCode) {
      case AccountErrorsEnum.UserNotFound:
        return "המשתמש לא נמצא";
      case AccountErrorsEnum.EmailNotExists:
        return "כתובת הדואר האלקטרוני לא קיימת";
      case AccountErrorsEnum.EmailAlreadyExists:
        return "כתובת הדואר האלקטרוני כבר קיימת";
      case AccountErrorsEnum.InvalidPassword:
        return "סיסמה לא תקינה";
      case AccountErrorsEnum.FaliedCreateUserToken:
        return "יצירת אסימון משתמש נכשלה";
      case AccountErrorsEnum.MismatchedPassword:
        return "הסיסמהות אינן תואמות";
      default:
        return "שגיאה לא ידועה";
    }
  };

  const handleSubmit = async (even) => {
    even.preventDefault();
    try {
      if (!validateForm()) return;

      const response = await accountActions.login(credentails);
      if (!validationHelper.validateHttpResponse(response, true)) {
        setErrors({ general: getLoginErrorMessage(response?.error?.code) });
        return;
      }

      navigate(-1);
    } catch (error) {}
  };

  const getEmailInputElement = () => {
    const inputProps = {
      ...textInputModel,
      name: "email",
      type: "email",
      error: errors.email,
      value: credentails.email,
      placeholder: "הכנס דואר אלקטרוני",
      onChange: handleInputChange,
    };
    return <TextInputElementComponent props={inputProps} />;
  };

  const getPasswordInputElement = () => {
    const inputProps = {
      ...textInputModel,
      name: "password",
      type: "password",
      error: errors.password,
      value: credentails.password,
      placeholder: "הכנס סיסמה",
      onChange: handleInputChange,
    };
    return <TextInputElementComponent props={inputProps} />;
  };

  return (
    <div className="accountDialogContainer">
      <h2>התחברות</h2>
      <form onSubmit={handleSubmit}>
        {getEmailInputElement()}
        {getPasswordInputElement()}
        <button type="submit" className="primaryButton">
          התחבר
        </button>
        <span className="error">{errors.general}</span>
      </form>
    </div>
  );
};

const mapStateToProps = (state, ownProps) => ({
  userReducer: state.userReducer,
  websiteReducer: state.websiteReducer,
});

const mapDispatchToProps = (dispatch) => {
  return {
    accountActions: bindActionCreators(accountActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountDialogContent);
